import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useAuthContext } from "@authentication/context";
import { Flex, Link } from "@base-ui";
import { Accordion } from "@interdependence-ui";
import adminEntries from "constants/adminEntries.json";
import { isNotEmptyArray } from "utils/validation";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLink = styled(function (props) {
  return /*#__PURE__*/_jsx(Link, _objectSpread({}, props));
}).withConfig({
  displayName: "AdminNavigation__StyledLink",
  componentId: "sc-njf3l4-0"
})(["&.active{background:none;box-shadow:none;pointer-events:none;font-family:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.robotoBold;
});
export var AdminNavigation = /*#__PURE__*/memo(function () {
  var _useAuthContext = useAuthContext(),
    getUserAccess = _useAuthContext.getUserAccess;
  var userAccess = getUserAccess();
  var navigate = useNavigate();
  var allowedEntries = adminEntries.filter(function (x) {
    return userAccess === null || userAccess === void 0 ? void 0 : userAccess[x.resource];
  }).map(function (x) {
    var _x$entries;
    return _objectSpread(_objectSpread({}, x), {}, {
      entries: (_x$entries = x.entries) === null || _x$entries === void 0 ? void 0 : _x$entries.filter(function (y) {
        return !y.resource || (userAccess === null || userAccess === void 0 ? void 0 : userAccess[y.resource]);
      })
    });
  });
  var handleSubLink = function handleSubLink(e, x) {
    e.preventDefault();
    if (location.pathname.includes("/indikatorer") && x.to.includes("/indikatorer")) {
      navigate("".concat(x.to).concat(location.search));
    } else navigate(x.to);
  };
  var withSubEntries = function withSubEntries(entry) {
    var _entry$entries;
    var subEntries = (_entry$entries = entry.entries) === null || _entry$entries === void 0 ? void 0 : _entry$entries.map(function (x) {
      return /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(StyledLink, {
          id: x.to,
          to: x.to,
          onClick: function onClick(e) {
            return handleSubLink(e, x);
          },
          style: {
            height: "25px",
            fontSize: "1.4rem",
            padding: "6px 20px 5px 40px"
          },
          children: x.name
        })
      }, x.to);
    });
    return /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Accordion, {
        id: "admin-navigation-".concat(entry.resource),
        title: entry.name,
        header: "h3",
        _open: location.pathname.includes(entry.to),
        children: /*#__PURE__*/_jsx("ul", {
          style: {
            margin: "-20px",
            width: "calc(100% + 40px)"
          },
          children: subEntries
        })
      })
    }, entry.to);
  };
  var withoutSubEntries = function withoutSubEntries(entry) {
    return /*#__PURE__*/_jsx("li", {
      style: {
        boxShadow: "0 1px 0 0 #A4DAE2"
      },
      children: /*#__PURE__*/_jsx(Link, {
        id: "admin-navigation-".concat(entry.resource),
        to: entry.to,
        style: {
          height: "60px"
        },
        children: entry.name
      })
    }, entry.to);
  };
  var entries = allowedEntries.map(function (entry) {
    return isNotEmptyArray(entry.entries) ? withSubEntries(entry) : withoutSubEntries(entry);
  });
  return /*#__PURE__*/_jsx(Flex.Column, {
    as: "ul",
    children: entries
  });
});